import React from 'react';

interface SkeletonRowProps {
  cols?: number;
}

export const SkeletonRow: React.FC<SkeletonRowProps> = ({ cols = 4 }) => (
  <tr className="animate-pulse">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className="px-4 py-3">
        <div className="h-4 bg-brand-border rounded w-3/4" />
      </td>
    ))}
  </tr>
);

export const TableSkeleton: React.FC<{ rows?: number; cols?: number }> = ({
  rows = 8,
  cols = 4,
}) => (
  <tbody>
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow key={i} cols={cols} />
    ))}
  </tbody>
);

export const CardSkeleton: React.FC = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-6 bg-brand-border rounded w-1/3" />
    <div className="h-4 bg-brand-border rounded w-2/3" />
    <div className="h-4 bg-brand-border rounded w-1/2" />
  </div>
);
